export default __webpack_public_path__ + "static/media/hm-sp-img.b196ea73.webp";